import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _34fec709 = () => interopDefault(import('../../../src/pages/aau.vue' /* webpackChunkName: "pages/aau" */))
const _331bba68 = () => interopDefault(import('../../../src/pages/aau/index.vue' /* webpackChunkName: "pages/aau/index" */))
const _3688fcf8 = () => interopDefault(import('../../../src/pages/aau/_slug.vue' /* webpackChunkName: "pages/aau/_slug" */))
const _d85e417e = () => interopDefault(import('../../../src/pages/about.vue' /* webpackChunkName: "pages/about" */))
const _ac654efc = () => interopDefault(import('../../../src/pages/accessibility.vue' /* webpackChunkName: "pages/accessibility" */))
const _7180ee8e = () => interopDefault(import('../../../src/pages/associations.vue' /* webpackChunkName: "pages/associations" */))
const _9cdb4d2e = () => interopDefault(import('../../../src/pages/careers.vue' /* webpackChunkName: "pages/careers" */))
const _2f852575 = () => interopDefault(import('../../../src/pages/CommunityHealthCenters.vue' /* webpackChunkName: "pages/CommunityHealthCenters" */))
const _a1ec0dc0 = () => interopDefault(import('../../../src/pages/consult.vue' /* webpackChunkName: "pages/consult" */))
const _34da3158 = () => interopDefault(import('../../../src/pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _2a8759c2 = () => interopDefault(import('../../../src/pages/front-end-implementations.vue' /* webpackChunkName: "pages/front-end-implementations" */))
const _b62606fe = () => interopDefault(import('../../../src/pages/mindshare.vue' /* webpackChunkName: "pages/mindshare" */))
const _3cbef2bc = () => interopDefault(import('../../../src/pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _55f23ba7 = () => interopDefault(import('../../../src/pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _cc7f524c = () => interopDefault(import('../../../src/pages/services.vue' /* webpackChunkName: "pages/services" */))
const _bafd0a8e = () => interopDefault(import('../../../src/pages/works/index.vue' /* webpackChunkName: "pages/works/index" */))
const _be6a4d1e = () => interopDefault(import('../../../src/pages/works/_slug.vue' /* webpackChunkName: "pages/works/_slug" */))
const _98ee8bf4 = () => interopDefault(import('../../../src/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _9c5bce84 = () => interopDefault(import('../../../src/pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/aau",
    component: _34fec709,
    children: [{
      path: "",
      component: _331bba68,
      name: "aau"
    }, {
      path: ":slug",
      component: _3688fcf8,
      name: "aau-slug"
    }]
  }, {
    path: "/about",
    component: _d85e417e,
    name: "about"
  }, {
    path: "/accessibility",
    component: _ac654efc,
    name: "accessibility"
  }, {
    path: "/associations",
    component: _7180ee8e,
    name: "associations"
  }, {
    path: "/careers",
    component: _9cdb4d2e,
    name: "careers"
  }, {
    path: "/CommunityHealthCenters",
    component: _2f852575,
    name: "CommunityHealthCenters"
  }, {
    path: "/consult",
    component: _a1ec0dc0,
    name: "consult"
  }, {
    path: "/contact",
    component: _34da3158,
    name: "contact"
  }, {
    path: "/front-end-implementations",
    component: _2a8759c2,
    name: "front-end-implementations"
  }, {
    path: "/mindshare",
    component: _b62606fe,
    name: "mindshare"
  }, {
    path: "/privacy",
    component: _3cbef2bc,
    name: "privacy"
  }, {
    path: "/search",
    component: _55f23ba7,
    name: "search"
  }, {
    path: "/services",
    component: _cc7f524c,
    name: "services"
  }, {
    path: "/works",
    component: _bafd0a8e,
    name: "works"
  }, {
    path: "/works/:slug",
    component: _be6a4d1e,
    name: "works-slug"
  }, {
    path: "/",
    component: _98ee8bf4,
    name: "index"
  }, {
    path: "/:slug",
    component: _9c5bce84,
    name: "slug"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
